import * as process from 'process';
// import 'zone.js'; // Included with Angular CLI.

// Attach the process object to the global window object
(window as any).process = process;
